import * as Sentry from '@sentry/browser'
import * as ReduxObservable from 'redux-observable'
import {ajax} from 'rxjs/ajax'
import {catchError, filter, map, mergeMap} from 'rxjs/operators'
import serializeError from 'serialize-error'
import * as Constants from './constants'
import {ErrorAction, RequestAction, SuccessAction} from './types'

const {ERROR, REQUEST, SUCCESS} = Constants

export const concurrentEpic: ReduxObservable.Epic = (action$, state$, {raven}) =>
action$.pipe(
  filter((action) => action.type.includes(REQUEST)),
  mergeMap((action: RequestAction) =>
    ajax({
      body: action.options.payload,
      headers: {
        'Content-Type': 'application/json',
        ...action.options.headers,
      },
      method: action.options.method,
      responseType: 'json',
      url: state$.value.config.api + action.options.url,
    }).pipe(
      map((payload: any): SuccessAction =>
        ({type: action.type.replace(REQUEST, SUCCESS), payload, requestAction: action}),
      ),
      catchError((error: Error): ErrorAction[] => {
        Sentry.captureException(error)
        return [{
          payload: {error: serializeError(error)},
          requestAction: action,
          type: action.type.replace(REQUEST, ERROR),
        }]
      },
      ),
    ),
  ),
)

export const epic = ReduxObservable.combineEpics( concurrentEpic )
